import React from 'react'
import { AnyToken } from 'src/common/types/models/Tokens'
import { sortTokensByBalanceValue } from 'src/common/utils/collections/sortByBalance'
import TokenSelectorItem from './TokenSelectorItem'

interface TokenSelectorListProps {
  tokens: AnyToken[]
  title?: string
  onSelectToken: (token: AnyToken) => void
  onInfoClick: (token: AnyToken) => void
  nftGroup?: boolean
}

const TokenSelectorList: React.FC<TokenSelectorListProps> = ({
  tokens,
  title,
  onSelectToken,
  onInfoClick,
  nftGroup,
}) => {
  const sortedTokens = sortTokensByBalanceValue(tokens)

  if (!tokens.length) return null

  return (
    <>
      {title && <div className='typo-label2'>{title}</div>}
      <div className='flex flex-col gap-1'>
        {sortedTokens.map(token => (
          <TokenSelectorItem
            key={token.contractAddress + token.tokenId}
            token={token}
            onClick={onSelectToken}
            onInfoClick={onInfoClick}
            nftGroup={nftGroup}
          />
        ))}
      </div>
    </>
  )
}

export default TokenSelectorList
